import { ItemList } from 'models/InputLayoutItem';

export const CreditLiquidationList: ItemList[] = [
	{ value: 'EUROCAPITAL SERVICIOS FINANCIEROS', label: 'EUROCAPITAL SERVICIOS FINANCIEROS' },
	{ value: 'NUEVO CAPITAL', label: 'NUEVO CAPITAL' },
	{ value: 'MUNDO CREDITO', label: 'MUNDO CREDITO' },
	{ value: 'GLOBAL SOLUCIONES FINANCIERAS S.A.', label: 'GLOBAL SOLUCIONES FINANCIERAS S.A.' },
	{ value: 'SANTANDER CONSUMER FINANCE', label: 'SANTANDER CONSUMER FINANCE' },
	{ value: 'BANCO CONSORCIO', label: 'BANCO CONSORCIO' },
	{ value: 'AUTOFIN', label: 'AUTOFIN' },
	{ value: 'BANCO INTERNACIONAL', label: 'BANCO INTERNACIONAL' },
	{ value: 'MARUBENI CREDIT', label: 'MARUBENI CREDIT' },
	{ value: 'CAJA DE COMPENSACION LOS HEROES', label: 'CAJA DE COMPENSACION LOS HEROES' },
	{ value: 'BANCO SECURITY', label: 'BANCO SECURITY' },
	{ value: 'MITSUI AUTO FINANCE', label: 'MITSUI AUTO FINANCE' },
	{ value: 'GMAC', label: 'GMAC' },
	{ value: 'COOPEUCH', label: 'COOPEUCH' },
	{ value: 'TANNER SERVICIOS FINANCIEROS S.A.', label: 'TANNER SERVICIOS FINANCIEROS S.A.' },
	{ value: 'BANCO DE CHILE', label: 'BANCO DE CHILE' },
	{ value: 'CREDICHILE', label: 'CREDICHILE' },
	{ value: 'BANCO EDWARDS', label: 'BANCO EDWARDS' },
	{ value: 'CITI', label: 'CITI' },
	{ value: 'CAJA DE COMPENSACION LA ARAUCANA', label: 'CAJA DE COMPENSACION LA ARAUCANA' },
	{ value: 'BANCO SCOTIABANK', label: 'BANCO SCOTIABANK' },
	{ value: 'BANCO BICE', label: 'BANCO BICE' },
	{ value: 'FORUM', label: 'FORUM' },
	{ value: 'BANCO ITAU CORPBANCA', label: 'BANCO ITAU CORPBANCA' },
	{ value: 'BANCO CONDELL', label: 'BANCO CONDELL' },
	{ value: 'BANCO BCI', label: 'BANCO BCI' },
	{ value: 'TBANC', label: 'TBANC' },
	{ value: 'NOVA', label: 'NOVA' },
	{ value: 'BANCO SANTANDER BANEFE', label: 'BANCO SANTANDER BANEFE' },
	{ value: 'BANCO ESTADO', label: 'BANCO ESTADO' },
	{ value: 'BANCO FALABELLA', label: 'BANCO FALABELLA' },
	{ value: 'BANCO RIPLEY', label: 'BANCO RIPLEY' },
	{ value: 'OTRAS ENTIDADES', label: 'OTRAS ENTIDADES' }
];
